import React from 'react';
import PropTypes from 'prop-types';

const TripTypeIcon = ({ 
  orientation = 'horizontal', 
  className = 'w-6 h-6',
  color = 'currentColor',
  strokeWidth = 2,
  ...props 
}) => {
  const HorizontalArrows = () => (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      className={className}
      {...props}
    >
      <path 
        d="M9 9L1 9M1 9L4 6M1 9L4 12" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M15 15L23 15M23 15L20 12M23 15L20 18" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );

  const VerticalArrows = () => (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      className={className}
      {...props}
    >
      <path 
        d="M9 9L9 1M9 1L6 4M9 1L12 4" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M15 15L15 23M15 23L12 20M15 23L18 20" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );

  return orientation === 'vertical' ? <VerticalArrows /> : <HorizontalArrows />;
};

TripTypeIcon.propTypes = {
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  className: PropTypes.string,
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
};

export default TripTypeIcon;